// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

const locale = Jsw.Locale.getSection('components.rating');

class VoteDialog extends Jsw.Popup {
    _initConfiguration(config) {
        super._initConfiguration({
            id: 'rating-dialog',
            title: locale.lmsg('voteTitle'),
            closeButtonEnabled: true,
            hideOnEscape: true,
            content: `${'' +
                `<p>${locale.lmsg('voteHint')}</p>` +
                '<hr/>' +
                '<div class="form-box form--vertical">' +
                    '<div class="box-area">' +
                        '<div class="content">' +
                            '<div class="content-area">' +
                                '<div class="nps-survey">' +
                                    '<p class="nps-survey__question">'}${locale.lmsg('voteQuestion')}</p>` +
                                    '<div class="nps-survey__container">' +
                                        '<div id="nps-rating" class="nps-survey__scores"></div>' +
                                        '<div class="nps-survey__legend">' +
                                            `<div class="nps-survey__legend-left">${locale.lmsg('voteLegendBad')}</div>` +
                                            `<div class="nps-survey__legend-right">${locale.lmsg('voteLegendGood')}</div>` +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<hr/>' +
                                '<div class="form-row">' +
                                    `<div class="field-name">${locale.lmsg('voteLikeHint')}</div>` +
                                    '<div class="field-value"><textarea id="rating-like" class="f-max-size" maxlength="1000"></textarea></div>' +
                                '</div>' +
                                '<div class="form-row">' +
                                    `<div class="field-name">${locale.lmsg('voteDislikeHint')}</div>` +
                                    '<div class="field-value"><textarea id="rating-dislike" class="f-max-size" maxlength="1000"></textarea></div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>',
            buttons: [{
                title: locale.lmsg('voteButtonOk'),
                id: 'rating-vote-button-ok',
                class: 'action',
                handler: this.handleVoteButton.bind(this),
            }, {
                title: locale.lmsg('voteButtonCancel'),
                id: 'rating-vote-button-cancel',
                handler(event, popup) {
                    popup.hide();
                },
            }],
            ...config,
        });

        this.dialogCause = this._getConfigParam('dialogCause');
        this.supportUrl = this._getConfigParam('supportUrl');
    }

    _initComponentElement() {
        super._initComponentElement();

        Jsw.render(this._componentElement.down('#nps-rating'), $R(0, 10).map(i => (
            Jsw.createElement('label', {
                class: `nps-survey__score nps-survey__score--${i}`,
                onclick: this.checkPossibleSendVote.bind(this),
            }, [
                Jsw.createElement('input', { type: 'radio', name: 'nps-survey-option', value: i }),
                Jsw.createElement('span', { class: 'nps-survey__score-label' }),
            ])
        )));
    }

    show() {
        super.show();
        this.showTime = Date.now();
    }

    hide() {
        super.hide();

        if (this.voted) {
            return;
        }

        if (this.checkPossibleSendVote() || this.getFeedbackLike() || this.getFeedbackDislike()) {
            this.sendVote();
        }

        if (this.dialogCause === 'timeout') {
            this.sendPostpone();
        }
    }

    handleVoteButton() {
        if (!this.checkPossibleSendVote()) {
            return;
        }

        this.voted = true;
        this.sendVote();
        this.hide();

        new ThankDialog({
            supportUrl: this.supportUrl,
            feedbackLike: this.getFeedbackLike(),
            feedbackDislike: this.getFeedbackDislike(),
        });
    }

    checkPossibleSendVote() {
        const survey = this._componentElement.down('.nps-survey');
        const rate = this.getRate();

        if (rate) {
            const errorField = survey.removeClassName('error').down('.field-errors');
            if (errorField) {
                errorField.remove();
            }
        } else {
            const errorField = survey.addClassName('error').down('.field-errors');
            if (!errorField) {
                survey.insert(
                    '<span class="field-errors">' +
                        `<span class="error-hint">${locale.lmsg('voteRequire')}</span>` +
                    '</span>'
                );
            }
        }

        return rate;
    }

    getRate() {
        return $(`${this.getId()}-form`)['nps-survey-option'].value;
    }

    getFeedbackLike() {
        return this._componentElement.down('#rating-like').value.trim();
    }

    getFeedbackDislike() {
        return this._componentElement.down('#rating-dislike').value.trim();
    }

    sendVote() {
        new Ajax.Request(
            Jsw.prepareUrl('/admin/rating/vote'),
            {
                method: 'post',
                parameters: {
                    voted: this.voted,
                    dialogCause: this.dialogCause,
                    rate: this.getRate(),
                    feedbackLike: this.getFeedbackLike(),
                    feedbackDislike: this.getFeedbackDislike(),
                    dialogDuration: Math.round((Date.now() - this.showTime) / 1000),
                    dialogAtPage: window.location.pathname,
                },
            }
        );
    }

    sendPostpone() {
        new Ajax.Request(
            Jsw.prepareUrl('/admin/rating/postpone'),
            { method: 'post' }
        );
    }
}

class ThankDialog extends Jsw.Popup {
    _initConfiguration(config) {
        let buttons = [{
            title: locale.lmsg('thankButtonClose'),
            class: 'action',
            handler(event, popup) {
                popup.hide();
            },
        }];

        let content = `<p>${locale.lmsg('thankHint')}</p>`;
        if (config.feedbackDislike) {
            const message = locale.lmsg('thankSupportCenter', {
                link: `<a id="rating-dialog-support-link" href="${config.supportUrl}" target="_blank">${locale.lmsg('supportCenter')}</a>`,
            });
            content += `<p>${message}</p>`;
        } else if (config.feedbackLike) {
            const introduction = locale.lmsg('introductionText', { message: config.feedbackLike });
            content += '<hr/>' +
                `<p>${locale.lmsg('thankSocialChoose')}</p>` +
                `<textarea id="rating-dialog-share-text" class="f-max-size">${introduction}</textarea>` +
                '<div class="social-links">' +
                    '<a id="rating-dialog-tweet-button" class="twitter-share-button">Tweet</a>' +
                    `<a id="rating-dialog-close-button"  class="ui-link--muted">${locale.lmsg('inviteButtonClose')}</a>` +
                '</div>';
            buttons = [];
        }

        super._initConfiguration({
            title: locale.lmsg('thankTitle'),
            closeButtonEnabled: true,
            hideOnEscape: true,
            content,
            buttons,
            ...config,
        });
    }

    _addEvents() {
        super._addEvents();

        if ($('rating-dialog-support-link')) {
            $('rating-dialog-support-link').observe('click', () => {
                new Ajax.Request(
                    Jsw.prepareUrl('/admin/rating/support-center'),
                    { method: 'post' }
                );
            });
        }
        if ($('rating-dialog-tweet-button')) {
            $('rating-dialog-tweet-button').observe('click', () => {
                window.open(
                    `${Jsw.prepareUrl('/admin/rating/social')}?button=twitter&text=${encodeURIComponent($('rating-dialog-share-text').value)}`,
                    'social-share',
                    'width=600,height=460'
                );
                this.hide();
            });
        }
        if ($('rating-dialog-close-button')) {
            $('rating-dialog-close-button').observe('click', () => {
                this.hide();
            });
        }
    }
}

module.exports = ({ buttonId, dialogCause, supportUrl }) => {
    $(buttonId).observe('click', () => {
        new VoteDialog({
            dialogCause: 'manual',
            supportUrl,
        });
    });

    if (dialogCause !== 'manual') {
        new VoteDialog({
            dialogCause,
            supportUrl,
        });
    }
};



// WEBPACK FOOTER //
// ./app/rating.js